/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cps: NonNullable<unknown> }} Event_Metrics_Cps_TitleInputs */



/**
* | output |
* | --- |
* | "{cps} Characters Per Second" |
*
* @param {Event_Metrics_Cps_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_cps_title = /** @type {((inputs: Event_Metrics_Cps_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Cps_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.cps} Caracteres par seconde`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.cps} Zeichen pro Sekunde`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.cps} Caratteri al secondo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.cps} символов в секунду`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.cps} Caracteres por segundo`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每秒字符数")
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.cps} 文字/秒`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.cps} वर्ण प्रति सेकंड`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.cps} Caracteres por segundo`)
	return /** @type {LocalizedString} */ (`${i?.cps} Characters Per Second`)
});